import React, { FC } from 'react'

import clsx from 'clsx'

import styles from './StepDots.module.scss'

export interface StepDotsProps {
  activeIndex: number
  ariaLabel: string
  className?: string
  total: number
}

export const StepDots: FC<StepDotsProps> = ({
  activeIndex,
  ariaLabel,
  className,
  total
}) => {
  return (
    <div
      className={clsx(styles.stepDots, className)}
      role='status'
      aria-label={ariaLabel}
    >
      {Array.from({ length: total }, (_, index) => (
        <span
          key={index}
          className={clsx(styles.stepDot, {
            [styles.stepDotActive]: index === activeIndex
          })}
        />
      ))}
    </div>
  )
}
